import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { getImageProps } from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { ArrowLeft, ArrowRight } from 'react-feather';
import Slider from 'react-slick';
import Icon from '../Icon';
import BannerHotspots from './bannerHotspots';
import HomeVideo from './HomeVideo';
import classes from './topCarousel.module.css';

const TopCarousel = ({ cmsVideos, cmsBanners }) => {
  const [slickReady, setSlickReady] = useState(false);

  if (!cmsBanners || !Array.isArray(cmsBanners)) {
    return null;
  }

  if (cmsBanners.length === 0 && cmsVideos.length === 0) {
    return null;
  }

  const sortBanners = banners => {
    return banners.sort((a, b) => {
      // 妫€鏌鍜宐鏄惁鏈夎锟?
      const aHasVideo = a.p_video || a.m_video;
      const bHasVideo = b.p_video || b.m_video;

      // 濡傛灉a鏈夎棰戣€宐娌℃湁锛宎鎺掑湪鍓嶉潰
      if (aHasVideo && !bHasVideo) {
        return -1;
      }
      // 濡傛灉b鏈夎棰戣€宎娌℃湁锛宐鎺掑湪鍓嶉潰
      if (!aHasVideo && bHasVideo) {
        return 1;
      }
      // 濡傛灉閮芥湁瑙嗛鎴栭兘娌℃湁瑙嗛锛屽垯鎸塸osition鎺掑簭
      return a.position - b.position;
    });
  };
  // clone涓€涓柊鏁扮粍
  const cmsBannersClone = sortBanners([...cmsBanners, ...cmsVideos]);
  
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;

    return (
      <div
        className={classes.rightNav}
        onClick={onClick}
      >
        <Icon
          src={ArrowRight}
          className={classes.navIcon}
          size={24}
        />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;

    return (
      <div
        className={classes.leftNav}
        onClick={onClick}
      >
        <Icon
          src={ArrowLeft}
          className={classes.navIcon}
          size={24}
        />
      </div>
    );
  }

  const sliderProps = {
    dots: true,
    infinite: true,
    showArrows: false,
    slidesToShow: 1,
    arrows: true,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: false,
    autoplaySpeed: 6000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    onInit: () => setSlickReady(true),
  };

  return (
    <Slider
      {...sliderProps}
      className={cn(classes.homebanner, !slickReady && classes.preInit)}
    >
      {[...cmsBannersClone].map((item, index) => {
        if (item.p_video && item.m_video) {
          return (
            <HomeVideo
              key={item.id}
              video={item}
            />
          );
        } else {
          const pcHotspots = item.pc_hotspots || [];
          const mHotspots = item.m_hotspots || [];
          // 图片和热区层放进同一个 stage：stage 的盒子就是图片本身的盒子，
          // 热区百分比坐标才对得上；container-type 让热区里的 cqw（字号、圆角、
          // 描边）按图片宽度等比缩放，和后台编辑器里看到的比例一致
          const stage = withFullLink => (
            <div className={classes.stage}>
              <picture className={classes.image}>
                {item.m_pic && <source media="(max-width: 640px)" srcSet={getImageProps({ src: item.m_pic, width: 750, height: 1100, alt: '', sizes: "100vw" }).props.srcSet} sizes="100vw" />}
                {item.p_pic && <source media="(min-width: 641px)" srcSet={getImageProps({ src: item.p_pic, width: 1920, height: 800, alt: '', quality: 85, sizes: "100vw" }).props.srcSet} />}
                <img
                  {...getImageProps({ src: item.p_pic, width: 1920, height: 800, alt: '', quality: 85, sizes: "100vw" }).props}
                  className={classes.image}
                  loading="eager"
                  fetchPriority={index === 0 ? "high" : "auto"}
                />
              </picture>
              {withFullLink && item.link && (
                <Link
                  href={item.link}
                  aria-label={item.title || ''}
                  className={cn(
                    classes.fullLink,
                    // 某一端配了热区就不要整图链接了，另一端仍然回落到整图链接
                    pcHotspots.length > 0 && classes.hideOnDesktop,
                    mHotspots.length > 0 && classes.hideOnMobile,
                  )}
                />
              )}
              <BannerHotspots hotspots={pcHotspots} device='pc' />
              <BannerHotspots hotspots={mHotspots} device='mobile' />
            </div>
          );

          return (
            <div
              className={classes.carouselItem}
              key={item.id}
            >
              {item.title && item.subtitle ? (
                <>
                  {index === 0 && (
                    <>
                      {item.p_pic && <link rel="preload" as="image" href={getImageProps({ src: item.p_pic, width: 1920, height: 800, alt: '', quality: 85, sizes: "100vw" }).props.src} imagesrcset={getImageProps({ src: item.p_pic, width: 1920, height: 800, alt: '', quality: 85, sizes: "100vw" }).props.srcSet} imagesizes="100vw" media="(min-width: 641px)" fetchPriority="high" />}
                      {item.m_pic && <link rel="preload" as="image" href={getImageProps({ src: item.m_pic, width: 750, height: 1100, alt: '', sizes: "100vw" }).props.src} imagesrcset={getImageProps({ src: item.m_pic, width: 750, height: 1100, alt: '', sizes: "100vw" }).props.srcSet} imagesizes="100vw" media="(max-width: 640px)" fetchPriority="high" />}
                    </>
                  )}
                  {stage(false)}
                </>
              ) : (
                <>
                  {index === 0 && (
                    <>
                      {item.p_pic && <link rel="preload" as="image" href={getImageProps({ src: item.p_pic, width: 1920, height: 800, alt: '', quality: 85, sizes: "100vw" }).props.src} media="(min-width: 641px)" fetchPriority="high" />}
                      {item.m_pic && <link rel="preload" as="image" href={getImageProps({ src: item.m_pic, width: 750, height: 1100, alt: '', sizes: "100vw" }).props.src} imagesrcset={getImageProps({ src: item.m_pic, width: 750, height: 1100, alt: '', sizes: "100vw" }).props.srcSet} imagesizes="100vw" media="(max-width: 640px)" fetchPriority="high" />}
                    </>
                  )}
                  {stage(true)}
                </>
              )}
              {/* <div className={cn(classes.infoBox)}> */}
              {item.title && item.subtitle && (
                <div className={cn('absolute left-0 top-0 flex h-full w-full items-center justify-center')}>
                  <div className='justify-cente container mx-auto flex h-full flex-col items-start justify-center pl-3 pt-[180px] lg_pl-0 lg_pt-0'>
                    <h2
                      className={cn('font-teko-medium font-medium uppercase', 'text-white', classes.infoTitle)}
                      style={{ textShadow: '0px 2px 10px rgba(0, 0, 0, 0.4)' }}
                    >
                      {item.title}
                    </h2>
                    <h3
                      className={cn('font-roboto-medium text-white', classes.infoSubTitle)}
                      style={{ textShadow: '0px 2px 10px rgba(0, 0, 0, 0.4)' }}
                    >
                      {item.subtitle}
                    </h3>

                    <Link href={item.link}>
                      <Button
                        className={cn(
                          'text-2sm bg-white font-roboto-medium capitalize text-primary',
                          classes.infoButton,
                        )}
                        variant='secondary'
                      >
                        {item.btn || 'Shop Now'}
                      </Button>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          );
        }
      })}
    </Slider>
  );
};

export default TopCarousel;
